import React from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { LegendItemText } from '../../style';
import { SecondaryToolbar } from '../../../../../ui-kit';
import { DateFromToPicker, ResetCallback, UpdateFromCallback, UpdateToCallback, useFromToContext } from '../../../../shared';
import { useDateTimeService } from '../../../../../utils/hooks/dateTimeService';
import { setUrlParams } from '../../../../../utils/helpers/urlParams';

const DashboardToolbar = () => {
    const { dateTimeService } = useDateTimeService();
    const { t } = useTranslation();
    const history = useHistory();
    const { dateFromTo, setDateFromTo } = useFromToContext();

    const updateFromContext: UpdateFromCallback = (from, dateTo) => {
        if (from) {
            const params = setUrlParams(history.location.search, {
                from: dateTimeService.getIsoDateStringFromJsDate(from),
            });
            history.push({ search: params.toString() });
        }

        if (from && dateTo && (from.valueOf() <= dateTo.valueOf())) {
            setDateFromTo({ from, to: dateTo.toJSDate() });
        }
        if (from === null) {
            resetContext();
        }
    };

    const updateToContext: UpdateToCallback = (to, dateFrom) => {
        if (to) {
            const params = setUrlParams(history.location.search, {
                to: dateTimeService.getIsoDateStringFromJsDate(to),
            });
            history.push({ search: params.toString() });
        }
        if (to && dateFrom && (to.valueOf() >= dateFrom.valueOf())) {
            setDateFromTo({ to, from: dateFrom.toJSDate() });
        }
        if (to === null) {
            resetContext();
        }
    };
    const resetContext: ResetCallback = () => {
        setDateFromTo(undefined);
    };

    let startDate;
    let endDate;
    if (dateFromTo) {
        startDate = dateTimeService.getDateTimeFromJsDate(dateFromTo.from);
        endDate = dateTimeService.getDateTimeFromJsDate(dateFromTo.to);
    }

    return (
        <SecondaryToolbar>
            <Box display='flex' flexGrow={1}>
                <Box alignItems='center' display='flex'>
                    <LegendItemText>{t('Overview')}</LegendItemText>
                </Box>
                <Box ml={2}>
                    <DateFromToPicker
                        startDate={startDate}
                        endDate={endDate}
                        updateFromCallback={updateFromContext}
                        updateToCallback={updateToContext}
                        hideReset
                    />
                </Box>
            </Box>
        </SecondaryToolbar>
    );
};

export default DashboardToolbar;
